import React from 'react';
import { createPortal } from 'react-dom';

export default function DeleteAttendanceDialog({ show, onClose, onConfirm }) {
  if (!show) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full animate-modal">
        <h3 className="text-lg font-semibold">Hapus Data Kehadiran?</h3>
        <p className="text-gray-500 mt-2">Data kehadiran ini akan dihapus secara permanen.</p>
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Batal
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
          >
            Hapus
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
